export const defaultInfos = [];
export const defaultCautions = [
  {
    contents:
      '기부 참여에 사용한 얼스 크레딧은 환불이 어려워요. 따라서 기부 전에 사용할 얼스 크레딧에 대해서 신중한 결정을 부탁드려요.',
  },
  {
    contents:
      '에코야얼스 얼스 크레딧를 통한 기부는 세금 공제 대상이 아니라서 기부 영수증은 발급이 어려워요.',
  },
  {
    contents:
      '기부 참여 후, 기부 내역은 에코야 얼스 앱 내 전체 > 기부하기에서 확인할 수 있어요.',
  },
  {
    contents:
      '기부 과정에서 기술적 문제가 발생할 경우, 에코야 얼스 앱 > 전체 > 1:1문의 페이지 혹은 에코야 얼스 카카오톡 채널에 문의해 주세요.',
  },
];
